import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import { cn } from "../lib/utils";

type ChoiceProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label: ReactNode;
  description?: ReactNode;
};

function ChoiceContent({ label, description }: Pick<ChoiceProps, "label" | "description">) {
  return (
    <span className="sqk-choice__copy">
      <span>{label}</span>
      {description ? <small>{description}</small> : null}
    </span>
  );
}

export const Checkbox = forwardRef<HTMLInputElement, ChoiceProps>(({
  label,
  description,
  className,
  ...props
}, ref) => (
  <label className={cn("sqk-choice", className)}>
    <input ref={ref} type="checkbox" {...props} />
    <span aria-hidden="true" className="sqk-choice__cell" />
    <ChoiceContent description={description} label={label} />
  </label>
));
Checkbox.displayName = "Checkbox";

export const Radio = forwardRef<HTMLInputElement, ChoiceProps>(({
  label,
  description,
  className,
  ...props
}, ref) => (
  <label className={cn("sqk-choice", className)}>
    <input ref={ref} type="radio" {...props} />
    <span aria-hidden="true" className="sqk-choice__cell" />
    <ChoiceContent description={description} label={label} />
  </label>
));
Radio.displayName = "Radio";
